import { TicketTypes } from "@tickets/constants";
import { getTicketData, checkAdminBarcode } from "@tickets/services";

export const TicketHandlers = {
  [TicketTypes.DEPOSIT]: getTicketData,
  [TicketTypes.SPORT]: getTicketData,
  [TicketTypes.CASINO]: getTicketData,
  [TicketTypes.ADMIN]: checkAdminBarcode,
};

export const getAllTickets = (tickets) => Object.values(tickets).flat();

export const checkIsTicketAlreadyAdded = (tickets, barcode) =>
  getAllTickets(tickets)?.some(
    (data) =>
      data.dataFromSwarm?.barcode === Number(barcode) ||
      `9${data.barcode}`.slice(0, -1) === barcode ||
      `20${data.dataFromCasino?.CasinoTransactionId}` === barcode ||
      data.originalBarcode === barcode // maybe this one can cover all cases
  );

export const isNotValidTicket = (ticket) => ticket.length < 8 || ticket.length >= 21;
